module.exports = "/_next/static/images/uniswap-79f58ab764e7ca8facfd3c642c5ae5e2.svg";